import Translatable from '../translatable_text/Translatable';


function Investors() {
  return (
    <div>
      <div
        className="footer-l section-padding bg-img mt-60"
        data-background="/light/assets/imgs/foter.webp"
        data-overlay-dark="9"
      >
        <div className="container ontop">
          <div className="row justify-content-center">
            <div className="col-lg-9">
              <div className="text-center wow d-rotate">
                <span className="butn butn-md butn-bord-thin radius-30 mb-30">
                  <span className="text">
                    <Translatable>
                      Investor Portal
                    </Translatable>
                  </span>
                </span>
                <h2 className="fz-70 rotate-text">
                  <Translatable>
                    Manage Your Investments and Grow Your Assets Today!
                  </Translatable>
                </h2>
                <a
                  href="https://app.rasmal.io/auth/signin"
                  target='_blank'
                  rel='noreferrer'
                  className="butn butn-bg butn-md radius-30 main-colorbg mt-30"
                >
                  <span>
                    <Translatable>
                      Check Your Investments
                    </Translatable>
                  </span>
                  <i className="fas fa-chart-line ml-10 mr-10"></i> 
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Investors;